var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgFormInstanceNotificationIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 18.75H3.75C3.4186 18.7496 3.10087 18.6178 2.86654 18.3835C2.6322 18.1491 2.50038 17.8314 2.5 17.5V2.5C2.50038 2.1686 2.6322 1.85087 2.86654 1.61654C3.10087 1.3822 3.4186 1.25038 3.75 1.25H16.25C16.5814 1.25038 16.8991 1.3822 17.1335 1.61654C17.3678 1.85087 17.4996 2.1686 17.5 2.5V17.5C17.4996 17.8314 17.3678 18.1491 17.1335 18.3835C16.8991 18.6178 16.5814 18.7496 16.25 18.75ZM3.75 2.5V17.5H16.25V2.5H3.75Z",
    fill: "#0F62FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 9.375L13.75 9.375V8.125H6.25V9.375Z",
    fill: "#0F62FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.5H12.5V11.25H7.5V12.5Z",
    fill: "#0F62FE"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgFormInstanceNotificationIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/form-instance-notification-icon.075c8b87b91b7b02232b0ff804b1306e.svg";